import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const OvScrollToTop: FC = () => {
  const location = useLocation();
  const initialLocation = useRef(location);

  useEffect(() => {
    if (location !== initialLocation.current) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default OvScrollToTop;
